import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import { formatNumber } from '../utilities/helpers';

import SVGIcon from './SVGIcon';
import DownloadButton from './public/DownloadButton'
import SelectionNotAvailable from './SelectionNotAvailable';

class BarGraph extends React.Component {
  state = {
    currentIndex: 0,
    barOnScreen: this.props.barOnScreen,
    selectValue: {},
    selectIndex: 0,
  };

  componentDidMount() {
    this.setStateValues();
  }

  setStateValues = () => {
    if (this.props.selectData) {
      this.setState(() => ({
        selectValue: this.props.selectData.map(item => ({
          label: item.name,
          value: item.name,
        }))[this.state.selectIndex],
      }));
    }
  };

  handleLeftButtonClick = () =>
    this.setState(prevState => ({
      currentIndex: Math.max(prevState.currentIndex - prevState.barOnScreen, 0),
    }));

  handleRightButtonClick = () => {
    if (
      this.state.currentIndex + this.state.barOnScreen <
      this.props.data.length
    ) {
      this.setState(prevState => ({
        currentIndex: Math.min(
          prevState.currentIndex + prevState.barOnScreen,
          Math.floor(this.props.data.length / prevState.barOnScreen) *
            prevState.barOnScreen
        ),
      }));
    }
  };

  handleSelect = event => this.setState(() => ({ selectValue: event }));

  render() {
    const {
      data,
      title,
      total,
      buttonOpen,
      subtitle,
      selectOpen,
      selectData,
      downloadOpen,
      statisticOpen,
      isDataAvailable,
    } = this.props;
    const topPercentage = this.props.data[0]
      ? Math.max(...this.props.data.map(item => item.sharePerCent))
      : 1;
    const topValue = this.props.data
      ? Math.max(...this.props.data.map(item => item.value))
      : 1;
    const topBrandAffinityValue = this.props.data
      ? Math.max(...this.props.data.map(item => item.brandAffinity))
      : 1;
    return (
      <React.Fragment>
        {isDataAvailable ? (
          <div className="WhereYourCustomersHaveBeenGraph">
            <div className="WhereYourCustomersHaveBeenGraph_top-row">
              <div className="WhereYourCustomersHaveBeenGraph_top-row_text">
                <h3 className="content-card_title">{title}</h3>
              </div>

              {buttonOpen && (
                <div>
                  <span className="WhereYourCustomersHaveBeenGraph_top-row_showing">
                    Showing {this.state.currentIndex + 1} -{' '}
                    {Math.min(
                      this.state.currentIndex + this.state.barOnScreen,
                      data.length
                    )}{' '}
                    of {data.length}
                  </span>
                  <div
                    className="WhereYourCustomersHaveBeenGraph_top-row_button-group"
                    data-html2canvas-ignore="true"
                  >
                    <button type="button" onClick={this.handleLeftButtonClick}>
                      <SVGIcon icon="left-arrow" />
                    </button>
                    <button type="button" onClick={this.handleRightButtonClick}>
                      <SVGIcon icon="right-arrow" />
                    </button>
                  </div>
                </div>
              )}

              {downloadOpen && (
                <DownloadButton
                    downloadAudience={this.props.downloadAudience}
                    downloadingCSV={this.props.downloadingCSV}
                    reportType={this.props.reportType}
                    insightType={this.props.insightType}
                    downloadParams={this.props.downloadOpen}
                />
              )}

              {selectOpen && (
                <div className="WhereYourCustomersHaveBeenGraph_top-row_select-group">
                  <Select
                    inputId="barChart"
                    className="WhereYourCustomersHaveBeenGraph_top-row_select"
                    placeholder="Select to search"
                    isDisabled={false}
                    isLoading={false}
                    isClearable
                    isRtl={false}
                    isSearchable
                    options={selectData.map(item => ({
                      label: item.name,
                      value: item.name,
                    }))}
                    onChange={this.handleSelect}
                    value={this.state.selectValue}
                  />
                </div>
              )}
            </div>

            {subtitle && (
              <p className="content-card_subtitle">
                {formatNumber(total)} {subtitle}
              </p>
            )}

            <div className="WhereYourCustomersHaveBeenGraph_barchart">
              <ul className="Barchart_ul">
                {data
                  .slice(
                    this.state.currentIndex,
                    this.state.currentIndex + this.state.barOnScreen
                  )
                  .map(
                    (item, index) => (
                        <li
                          className="Barchart_li"
                          key={index}
                          style={{ width: `${100 / this.state.barOnScreen}%` }}
                        >
                          <div className="Barchart_statistic-container">
                            {statisticOpen && (
                              <span className="Barchart_statistic">
                                ({' '}
                                {!isNaN(item.penetration)
                                  ? (item.penetration * 100).toFixed(2)
                                  : item.penetration * 100}
                                % / &plusmn;
                                {!isNaN(item.confidence)
                                  ? (item.confidence * 100).toFixed(2)
                                  : item.confidence * 100}
                                % )
                              </span>
                            )}
                          </div>

                          <span
                            className={`Barchart${
                              item.brandAffinity !== undefined &&
                              item.brandAffinity !== null
                                ? '_affinity'
                                : '_sharePerCent'
                            }
                  `}
                          >
                            {'sharePerCent' in item
                              ? item.sharePerCent.toFixed(2) < 0.01
                                ? '< 0.01%'
                                : `${item.sharePerCent.toFixed(2)}%`
                              : 'value' in item
                              ? item.value.toFixed(2)
                              : `${item.brandAffinity.toFixed(2)}x`}
                          </span>
                          <span className="Barchart_name">
                            {item.organisation && (
                              <span>
                                {item.organisation} <br />
                              </span>
                            )}
                            {item.name}
                          </span>
                          <span className="Barchart_bars">
                            <span className="Barchart_bar-wrapper">
                              <span
                                className={`Barchart_bar_this-month${
                                  item.value && item.value < 1
                                    ? '_negative'
                                    : ''
                                }`}
                                style={{
                                  height: `${
                                    item.sharePerCent
                                      ? (item.sharePerCent / topPercentage) *
                                        100
                                      : item.value
                                      ? (Math.abs(item.value) / topValue) * 100
                                      : (Math.abs(item.brandAffinity) /
                                          topBrandAffinityValue) *
                                        100
                                  }%`,
                                }}
                              />
                            </span>
                            {/* <span className="Barchart_percentageChange">
                    {item.percentageChange}%
                  </span> */}
                          </span>
                        </li>
                      )
                  )}
              </ul>
            </div>
          </div>
        ) : (
          <SelectionNotAvailable
            text="Graph Currently Unavailable"
            buttonText=""
          />
        )}
      </React.Fragment>
    );
  }
}

BarGraph.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
  barOnScreen: PropTypes.number.isRequired,
  total: PropTypes.number,
  button: PropTypes.bool,
  isDataAvailable: PropTypes.bool,
};

BarGraph.defaultProp = {
  buttonOpen: false,
  selectOpen: false,
  downloadOpen: false,
  statisticOpen: false,
  subtitle: '',
  barOnScreen: 10,
  total: 99999,
  isDataAvailable: true,
};

export default BarGraph;
